import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BackButton } from "@/components/ui/back-button";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-4xl mx-auto pt-16">
        <div className="fixed top-4 left-4 z-50">
          <BackButton onClick={() => navigate(-1)} />
        </div>

        <h1 className="text-4xl font-bold mb-8">{t('legal.privacy.title')}</h1>

        <div className="space-y-8 text-foreground/90">
          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.matters_title')}</h2>
            <p className="mb-4">
              {t('legal.privacy.matters_desc')}
            </p>
            <p className="mb-4">
              <strong>{t('legal.privacy.service_provider')}:</strong> gitfit.ai<br />
              <strong>{t('legal.privacy.location')}:</strong>{t('ui.text.united_states')}<br />
              <strong>{t('legal.privacy.contact')}:</strong> <a href="/contact-us" className="text-blue-500 hover:underline">{t('legal.privacy.contact_link')}</a>
            </p>
            <p className="mb-4 font-semibold">
              {t('legal.privacy.children_warning')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.collect_title')}</h2>
            <p className="mb-4">{t('legal.privacy.collect_intro')}</p>

            <h3 className="text-xl font-semibold mb-2 mt-4">{t('legal.privacy.account_info')}</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.privacy.account_email')}</li>
              <li>{t('legal.privacy.account_username')}</li>
              <li>{t('legal.privacy.account_profile')}</li>
            </ul>

            <h3 className="text-xl font-semibold mb-2 mt-4">{t('legal.privacy.health_info')}</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.privacy.health_logs')}</li>
              <li>{t('legal.privacy.health_goals')}</li>
              <li>{t('legal.privacy.health_progress')}</li>
              <li>{t('legal.privacy.health_healthkit')}</li>
            </ul>

            <h3 className="text-xl font-semibold mb-2 mt-4">{t('legal.privacy.healthkit_usage_title')}</h3>
            <p className="mb-4">
              {t('legal.privacy.healthkit_usage_desc')}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.privacy.healthkit_usage_1')}</li>
              <li>{t('legal.privacy.healthkit_usage_2')}</li>
              <li>{t('legal.privacy.healthkit_usage_3')}</li>
              <li>{t('legal.privacy.healthkit_usage_4')}</li>
              <li>{t('legal.privacy.healthkit_usage_5')}</li>
            </ul>

            <h3 className="text-xl font-semibold mb-2 mt-4">{t('legal.privacy.usage_data')}</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.privacy.usage_interaction')}</li>
              <li>{t('legal.privacy.usage_preferences')}</li>
              <li>{t('legal.privacy.usage_technical')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.protect_title')}</h2>
            <p className="mb-4">{t('legal.privacy.protect_intro')}</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>{t('legal.privacy.protect_tls')}:</strong> {t('legal.privacy.protect_tls_desc')}</li>
              <li><strong>{t('legal.privacy.protect_encryption')}:</strong> {t('legal.privacy.protect_encryption_desc')}</li>
              <li>{t('legal.privacy.protect_auth')}</li>
              <li>{t('legal.privacy.protect_audits')}</li>
              <li>{t('legal.privacy.protect_access')}</li>
              <li>{t('legal.privacy.protect_rate')}</li>
              <li>{t('legal.privacy.protect_standard')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.use_title')}</h2>
            <p className="mb-4">{t('legal.privacy.use_intro')}</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{t('legal.privacy.use_improve')}</li>
              <li>{t('legal.privacy.use_track')}</li>
              <li>{t('legal.privacy.use_notify')}</li>
              <li>{t('legal.privacy.use_social')}</li>
              <li>{t('legal.privacy.use_payment')}</li>
              <li>{t('legal.privacy.use_support')}</li>
              <li>{t('legal.privacy.use_fraud')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.dont_title')}</h2>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>{t('legal.privacy.dont_sell')}</strong></li>
              <li>{t('legal.privacy.dont_share')}</li>
              <li>{t('legal.privacy.dont_spam')}</li>
              <li>{t('legal.privacy.dont_explicit')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.ai_title')}</h2>
            <p className="mb-4">
              {t('legal.privacy.ai_intro')}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>{t('legal.privacy.ai_processing')}:</strong> {t('legal.privacy.ai_processing_desc')}</li>
              <li><strong>{t('legal.privacy.ai_location')}:</strong> {t('legal.privacy.ai_location_desc')}</li>
              <li><strong>{t('legal.privacy.ai_terms')}:</strong> {t('legal.privacy.ai_terms_desc')}</li>
              <li><strong>{t('legal.privacy.ai_transmission')}:</strong> {t('legal.privacy.ai_transmission_desc')}</li>
              <li><strong>{t('legal.privacy.ai_retention')}:</strong> {t('legal.privacy.ai_retention_desc')}</li>
              <li><strong>{t('legal.privacy.ai_openai')}:</strong> {t('legal.privacy.ai_openai_desc')}{" "}
                <a
                  href="https://openai.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  {t('legal.privacy.ai_openai_link')}
                </a>
                {" "}{t('legal.privacy.ai_openai_desc_2')}
              </li>
              <li><strong>{t('legal.privacy.ai_rights')}:</strong> {t('legal.privacy.ai_rights_desc')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.sharing_title')}</h2>
            <p className="mb-4">
              {t('legal.privacy.sharing_intro')}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>{t('legal.privacy.sharing_consent')}:</strong> {t('legal.privacy.sharing_consent_desc')}</li>
              <li><strong>{t('legal.privacy.sharing_providers')}:</strong> {t('legal.privacy.sharing_providers_desc')}</li>
              <li><strong>{t('legal.privacy.sharing_legal')}:</strong> {t('legal.privacy.sharing_legal_desc')}</li>
            </ul>
            <p className="mt-4">
              <strong>{t('legal.privacy.sharing_restore')}:</strong> {t('legal.privacy.sharing_restore_desc')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.rights_title')}</h2>
            <p className="mb-4">{t('legal.privacy.rights_intro')}</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>{t('legal.privacy.rights_access')}:</strong> {t('legal.privacy.rights_access_desc')}</li>
              <li><strong>{t('legal.privacy.rights_correct')}:</strong> {t('legal.privacy.rights_correct_desc')}</li>
              <li><strong>{t('legal.privacy.rights_delete')}:</strong> {t('legal.privacy.rights_delete_desc')}</li>
              <li><strong>{t('legal.privacy.rights_export')}:</strong> {t('legal.privacy.rights_export_desc')}</li>
              <li><strong>{t('legal.privacy.rights_optout')}:</strong> {t('legal.privacy.rights_optout_desc')}</li>
              <li><strong>{t('legal.privacy.rights_object')}:</strong> {t('legal.privacy.rights_object_desc')}</li>
            </ul>
            <p className="mt-4">
              <strong>{t('legal.privacy.rights_retention_title')}:</strong> {t('legal.privacy.rights_retention_desc')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.children_title')}</h2>
            <p className="mb-4">
              {t('legal.privacy.children_desc_1')}
            </p>
            <p className="mb-4">
              {t('legal.privacy.children_desc_2')}
            </p>
            <p className="mb-4">
              {t('legal.privacy.children_desc_3')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.international_title')}</h2>
            <p className="mb-4">
              {t('legal.privacy.international_desc_1')}
            </p>
            <p className="mb-4">
              {t('legal.privacy.international_desc_2')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.updates_title')}</h2>
            <p className="mb-4">
              {t('legal.privacy.updates_desc')}
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">{t('legal.privacy.contact_title')}</h2>
            <p className="mb-4">
              {t('legal.privacy.contact_intro')}{' '}
              <a href="/contact-us" className="text-primary hover:underline">{t('legal.privacy.contact_page')}</a>.
            </p>
          </section>

          <section className="pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground">
              {t('legal.last_updated', { date: new Date().toLocaleDateString() })}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
